export const getTheme = theme => {
  return require("./".concat(theme, ".module.css"));
};